<template>
  <div class="adm-page">
    <div class="adm-container">
      <!-- 面包屑导航 -->
      <nav class="breadcrumb-nav">
        <router-link to="/">首页</router-link>
        <span class="separator">/</span>
        <router-link to="/product">产品中心</router-link>
        <span class="separator">/</span>
        <span class="current">审计数据集市</span>
      </nav>
    </div>

    <!-- 英雄区（产品Banner） -->
    <section class="adm-container" style="padding-top: 20px;">
      <div style="max-width: 1000px;">
        <h1>审计数据集市<br><span style="color: var(--adm-accent-blue);">企业级审计数据中台</span></h1>
        <p class="subhead">整合多源审计数据，构建统一数据底座，为审计模型、风险矩阵与监督评价体系提供高质量数据支撑，打造"数据驱动+模型赋能"的智慧审计体系。</p>
        <div style="display: flex; gap: 20px; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal">预约演示 <i class="fa-regular fa-calendar-check" style="margin-left: 8px;"></i></a>
          <a href="#" class="btn btn-outline" @click.prevent="downloadBrochure">下载产品手册 <i class="fa-regular fa-file-pdf" style="margin-left: 8px;"></i></a>
        </div>
      </div>

      <!-- 关键词云（SEO强化） -->
      <div class="keyword-cloud">
        <h2 class="keyword-tag highlight">审计数据集市</h2>
        <h2 class="keyword-tag">审计数据中台</h2>
        <h2 class="keyword-tag">审计数据治理</h2>
        <h2 class="keyword-tag">风险数据集市</h2>
        <h2 class="keyword-tag">智能审计数据底座</h2>
        <h2 class="keyword-tag">审计模型数据源</h2>
        <h2 class="keyword-tag">审计数据整合</h2>
        <h2 class="keyword-tag">企业风险数据平台</h2>
        <h2 class="keyword-tag">大数据审计</h2>
        <h2 class="keyword-tag">审计知识库</h2>
      </div>
    </section>

    <!-- 行业背景与痛点 -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-triangle-exclamation"></i> 行业背景与核心痛点</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-database"></i></div>
          <h3>数据分散，难以整合</h3>
          <p>财务、运营、合规系统独立运行，数据标准不统一，重复存储，难以直接支撑智能审计模型。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-chart-line"></i></div>
          <h3>审计模型缺乏高质量数据</h3>
          <p>数据缺失严重，指标口径不一致，历史成果未沉淀，导致模型精度不足。</p>
        </div>
        <div class="feature-card">
          <div class="card-icon"><i class="fa-regular fa-clock"></i></div>
          <h3>历史成果无法沉淀利用</h3>
          <p>审计底稿、工单、报告未结构化，知识库未系统化管理，风险轨迹无法持续跟踪。</p>
        </div>
      </div>
      <p style="margin-top: 20px; font-size: 1.1rem;">在数字化审计、科技强审、审计全覆盖背景下，构建企业级审计数据集市已成为实现审计数字化转型的基础工程。</p>
    </section>

    <!-- 产品定位 -->
    <section class="adm-container">
      <div class="arch-card" style="background: var(--adm-primary-dark); color: white;">
        <h2 style="color: white; margin-bottom: 20px;">产品定位：企业级审计数据中枢</h2>
        <p style="font-size: 1.2rem; max-width: 900px; margin: 0 auto;">审计数据集市是企业级审计数据中枢平台，核心定位为：审计数据集中管理平台、风险数据统一治理平台、审计模型数据支撑平台、审计成果沉淀与分析平台，实现数据统一、口径一致、风险可追溯、模型可复用。</p>
      </div>
    </section>

    <!-- 核心功能模块（四个卡片，带颜色标识） -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-cubes"></i> 核心功能模块</h2>
      <div class="card-grid-4">
        <!-- 模块一：多源数据整合管理 -->
        <div class="feature-card module-red">
          <div class="card-icon"><i class="fa-regular fa-cloud-arrow-up"></i></div>
          <h3>多源数据整合管理</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 财务/ERP/NC系统数据</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 审计工单与底稿数据</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 法律法规与知识库数据</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> ETL、标准化、清洗建模</li>
          </ul>
          <div style="margin-top: 16px;">
            <span class="keyword-tag">数据整合</span>
            <span class="keyword-tag">ETL</span>
            <span class="keyword-tag">数据中台</span>
          </div>
        </div>

        <!-- 模块二：审计成果沉淀与结构化管理 -->
        <div class="feature-card module-blue">
          <div class="card-icon"><i class="fa-regular fa-folder-open"></i></div>
          <h3>审计成果沉淀与结构化管理</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 审计报告/工单/底稿结构化</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 知识库系统化管理</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 审计知识图谱</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 全文检索与风险标签</li>
          </ul>
          <div style="margin-top: 16px;">
            <span class="keyword-tag">审计知识库</span>
            <span class="keyword-tag">成果沉淀</span>
            <span class="keyword-tag">风险标签</span>
          </div>
        </div>

        <!-- 模块三：风险数据汇总分析 -->
        <div class="feature-card module-green">
          <div class="card-icon"><i class="fa-regular fa-chart-pie"></i></div>
          <h3>风险数据汇总分析</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 重点风险汇总分析</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 共性风险趋势分析</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险频次与金额统计</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 风险趋势预测</li>
          </ul>
          <div style="margin-top: 16px;">
            <span class="keyword-tag">风险大数据</span>
            <span class="keyword-tag">共性风险</span>
            <span class="keyword-tag">趋势分析</span>
          </div>
        </div>

        <!-- 模块四：审计模型数据支撑引擎 -->
        <div class="feature-card module-yellow">
          <div class="card-icon"><i class="fa-regular fa-microchip"></i></div>
          <h3>审计模型数据支撑引擎</h3>
          <ul style="list-style: none; margin-top: 12px;">
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 为审计模型提供标准化数据</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑风险矩阵系统</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 支撑监督评价体系</li>
            <li class="list-item"><i class="fa-regular fa-circle-check"></i> 持续非现场数据支持</li>
          </ul>
          <div style="margin-top: 16px;">
            <span class="keyword-tag">模型数据源</span>
            <span class="keyword-tag">API接口</span>
            <span class="keyword-tag">指标库</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术架构亮点 -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-diagram-project"></i> 技术架构亮点</h2>
      <div class="arch-card">
        <div style="display: flex; flex-wrap: wrap; gap: 20px; align-items: center; justify-content: center; margin-bottom: 30px;">
          <span class="compliance-badge">数据中台架构</span>
          <span class="compliance-badge">分层数仓(ODS/DW/DM)</span>
          <span class="compliance-badge">风险指标模型库</span>
          <span class="compliance-badge">BI可视化</span>
          <span class="compliance-badge">ERP/财务系统对接</span>
          <span class="compliance-badge">审计数据治理体系</span>
        </div>
        <div class="arch-grid">
          <div class="arch-item">
            <i class="fa-regular fa-layer-group" style="font-size: 2rem; color: var(--adm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>分层数据仓库</h4>
            <p>ODS操作数据层、DW数据仓库层、DM数据集市层，清晰分层，支持多场景数据应用。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-chart-line" style="font-size: 2rem; color: var(--adm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>风险指标模型库</h4>
            <p>内置风险量化指标、共性风险识别模型，支持持续优化与扩展。</p>
          </div>
          <div class="arch-item">
            <i class="fa-regular fa-chart-pie" style="font-size: 2rem; color: var(--adm-primary-dark); margin-bottom: 16px; display: block;"></i>
            <h4>BI可视化分析</h4>
            <p>动态仪表盘、风险热力图、数据下钻，辅助管理层快速洞察风险。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型应用场景 -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-building"></i> 典型应用场景</h2>
      <div class="card-grid-3">
        <div class="feature-card">
          <i class="fa-regular fa-chart-simple card-icon"></i>
          <h3>智慧审计风险管控评估</h3>
          <p>构建企业风险画像，支撑风险矩阵模型，实现风险实时监控与预警。</p>
          <div style="margin-top: 16px;"><span class="keyword-tag">风险画像</span> <span class="keyword-tag">实时监控</span></div>
        </div>
        <div class="feature-card">
          <i class="fa-regular fa-box-archive card-icon"></i>
          <h3>审计成果最大化应用</h3>
          <p>审计问题沉淀、历史数据对比分析、风险轨迹追踪，支撑决策优化。</p>
          <div style="margin-top: 16px;"><span class="keyword-tag">成果沉淀</span> <span class="keyword-tag">轨迹追踪</span></div>
        </div>
        <div class="feature-card">
          <i class="fa-regular fa-bullseye card-icon"></i>
          <h3>审计转型价值创造</h3>
          <p>风险防控前置、事前预警、事中监控，推动审计从"纠错型"向"价值型"转型。</p>
          <div style="margin-top: 16px;"><span class="keyword-tag">风险前置</span> <span class="keyword-tag">价值审计</span></div>
        </div>
      </div>
    </section>

    <!-- 产品核心优势 -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-star"></i> 产品核心优势</h2>
      <div class="card-grid-4">
        <div class="feature-card">
          <i class="fa-regular fa-rocket card-icon" style="color: var(--adm-accent-blue);"></i>
          <h3>提升监督评价力度</h3>
          <p>整合历史审计成果、工单、底稿、法规与知识库，实现风险管理有效性评估。</p>
        </div>
        <div class="feature-card">
          <i class="fa-regular fa-chart-line card-icon" style="color: var(--adm-accent-blue);"></i>
          <h3>强化风险汇总分析</h3>
          <p>重点风险、共性风险量化监控，构建企业级风险监督体系。</p>
        </div>
        <div class="feature-card">
          <i class="fa-regular fa-clock card-icon" style="color: var(--adm-accent-blue);"></i>
          <h3>构建风险轨迹数据库</h3>
          <p>洞察过去风险轨迹，预测未来风险趋势，实现风险可追溯。</p>
        </div>
        <div class="feature-card">
          <i class="fa-regular fa-cubes card-icon" style="color: var(--adm-accent-blue);"></i>
          <h3>支撑多系统协同</h3>
          <p>为审计监督评价、风险矩阵、干部履职评价提供高质量数据支撑。</p>
        </div>
      </div>
    </section>

    <!-- 项目成果与价值（数据指标） -->
    <section class="adm-container">
      <h2><i class="fa-regular fa-chart-simple"></i> 项目成果与价值</h2>
      <div class="stat-grid">
        <div class="stat-card">
          <div class="stat-number">40%-70%</div>
          <p>数据质量提升</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">显著增强</div>
          <p>风险识别能力</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">长期</div>
          <p>数据资产沉淀</p>
        </div>
        <div class="stat-card">
          <div class="stat-number">转型</div>
          <p>价值创造型审计</p>
        </div>
      </div>
      <div style="margin-top: 40px;">
        <ul style="list-style: none; display: flex; flex-wrap: wrap; gap: 30px; justify-content: center;">
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 统一数据口径，提高审计数据准确性</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 共性风险可量化、可追踪</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 实现数据资产沉淀与长期复用</li>
          <li class="list-item"><i class="fa-regular fa-circle-check"></i> 推动企业从差错纠弊向风险前置、价值创造转型</li>
        </ul>
      </div>
    </section>

    <!-- 常见问题 FAQ -->
    <section class="adm-container">
      <h2 style="text-align: center;"><i class="fa-regular fa-circle-question"></i> 常见问题</h2>
      <div class="faq-list">
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 审计数据集市与数据仓库有何区别？</div>
          <div class="faq-answer">数据集市是面向特定主题（审计）的数据仓库子集，更聚焦审计业务场景，提供预计算的风险指标和模型支撑，响应更快。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何保证数据质量与一致性？</div>
          <div class="faq-answer">通过ETL过程中的数据清洗、标准化、质量校验，建立数据治理体系，确保进入集市的数据口径统一、准确可靠。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 是否支持实时数据接入？</div>
          <div class="faq-answer">支持批量与实时两种模式，可根据业务需求配置数据同步频率，满足持续非现场审计对时效性的要求。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 如何与现有审计系统集成？</div>
          <div class="faq-answer">提供标准化API接口，可无缝对接古杉非现场审计平台、风险矩阵系统及其他第三方审计软件。</div>
        </div>
        <div class="faq-item">
          <div class="faq-question"><i class="fa-regular fa-message"></i> 实施周期需要多久？</div>
          <div class="faq-answer">一般2-3个月完成试点上线，包括数据源梳理、ETL开发、模型配置和人员培训。</div>
        </div>
      </div>
    </section>

    <!-- 最终CTA -->
    <section class="adm-container" style="padding-bottom: 80px;">
      <div class="cta-block">
        <h2 style="font-size: 2.4rem;">构建企业级审计数据集市</h2>
        <p style="font-size: 1.2rem; margin: 16px 0 40px; opacity: 0.9;">预约专家演示，了解如何整合审计数据，为模型与评价体系提供坚实数据底座。</p>
        <div style="display: flex; gap: 20px; justify-content: center; flex-wrap: wrap;">
          <a href="#" class="btn btn-primary" @click.prevent="openModal" style="background: white; color: var(--adm-primary-dark);">预约免费演示</a>
          <a href="tel:4008881234" class="btn btn-outline" style="border-color: white; color: white;">致电 400-888-1234</a>
        </div>
        <p style="margin-top: 32px; font-size: 1rem;"><i class="fa-regular fa-envelope"></i> 发送需求至 datamart@gushandata.cn</p>
      </div>
    </section>

    <!-- 预约演示模态框 -->
    <div class="modal" :style="{ display: showModal ? 'flex' : 'none' }">
      <div class="modal-content">
        <span class="close-modal" @click="closeModal">&times;</span>
        <h3><i class="fa-regular fa-calendar-check" style="color: var(--adm-primary-dark);"></i> 预约专家演示</h3>
        <form @submit.prevent="submitDemo">
          <div class="form-group">
            <input type="text" v-model="form.name" placeholder="姓名 *" required>
          </div>
          <div class="form-group">
            <input type="text" v-model="form.company" placeholder="公司名称">
          </div>
          <div class="form-group">
            <input type="email" v-model="form.email" placeholder="工作邮箱 *" required>
          </div>
          <div class="form-group">
            <input type="tel" v-model="form.phone" placeholder="联系电话">
          </div>
          <div class="form-group">
            <textarea rows="3" v-model="form.message" placeholder="您的需求或问题（选填）"></textarea>
          </div>
          <button type="submit" class="btn btn-primary">提交预约</button>
        </form>
      </div>
    </div>

    <!-- footer -->
    <footer class="adm-container">
      <p>© 2026 古杉数据 · 审计数据集市 | 企业级审计数据中台 · 高质量数据底座</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AuditDataMarketDetail',
  data() {
    return {
      showModal: false,
      form: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    submitDemo() {
      alert('感谢您的预约，古杉数据专家将在24小时内与您联系。');
      this.showModal = false;
      this.form = { name: '', company: '', email: '', phone: '', message: '' };
    },
    downloadBrochure() {
      alert('产品手册下载中…… (实际可替换为PDF链接)');
    }
  }
};
</script>

<style scoped>
.adm-page {
  --adm-primary-dark: #1D4E4E;
  --adm-primary-soft: #e9f3f2;
  --adm-accent-gold: #D4AF37;
  --adm-accent-blue: #2A7DE1;
  --adm-gray-light: #f8fafc;
  --adm-gray-border: #e2e8f0;
  --adm-text-dark: #0f2a2a;
  --adm-text-regular: #2d3f4b;
  --adm-white: #ffffff;
  --adm-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);

  background-color: #ffffff;
  color: var(--adm-text-regular);
  line-height: 1.5;
  font-family: 'Inter', 'PingFang SC', 'Roboto', system-ui, -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 面包屑导航 */
.breadcrumb-nav {
  padding: 20px 0;
  font-size: 0.9rem;
  border-bottom: 1px solid var(--adm-gray-border);
  margin-bottom: 20px;
}

.breadcrumb-nav a {
  color: var(--adm-primary-dark);
  text-decoration: none;
  font-weight: 500;
}

.breadcrumb-nav a:hover {
  text-decoration: underline;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #999;
}

.breadcrumb-nav .current {
  color: var(--adm-accent-blue);
  font-weight: 600;
}

.adm-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}

section.adm-container {
  padding: 64px 24px;
}

h1, h2, h3 {
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--adm-text-dark);
}

h1 {
  font-size: 3.2rem;
  line-height: 1.2;
}

h2 {
  font-size: 2.2rem;
  margin-bottom: 24px;
}

h2 i {
  color: var(--adm-accent-blue);
  margin-right: 8px;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 12px;
}

.subhead {
  font-size: 1.2rem;
  color: #4f6f7f;
  max-width: 800px;
  margin-bottom: 40px;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  border-radius: 40px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  font-size: 1rem;
  border: 1px solid transparent;
  cursor: pointer;
}

.btn-primary {
  background-color: var(--adm-primary-dark);
  color: white;
  box-shadow: 0 4px 12px rgba(29, 78, 78, 0.25);
}

.btn-primary:hover {
  background-color: #0e3a3a;
  transform: translateY(-2px);
}

.btn-outline {
  background-color: transparent;
  border: 1.5px solid var(--adm-primary-dark);
  color: var(--adm-primary-dark);
}

.btn-outline:hover {
  background-color: var(--adm-primary-dark);
  color: white;
}

.btn-accent {
  background-color: var(--adm-accent-blue);
  color: white;
  box-shadow: 0 4px 12px rgba(42, 125, 225, 0.3);
}

.btn-accent:hover {
  background-color: #1b64c5;
  transform: translateY(-2px);
}

/* 关键词标签云 */
.keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 30px 0 20px;
}

.keyword-tag {
  background: var(--adm-primary-soft);
  color: var(--adm-primary-dark);
  padding: 6px 16px;
  border-radius: 40px;
  font-size: 0.85rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.keyword-tag.highlight {
  background: var(--adm-accent-gold);
  color: #1e3c3c;
}

/* 卡片网格 */
.card-grid-3, .card-grid-4 {
  display: grid;
  gap: 24px;
  margin: 40px 0;
}

.card-grid-3 {
  grid-template-columns: repeat(3, 1fr);
}

.card-grid-4 {
  grid-template-columns: repeat(4, 1fr);
}

.feature-card {
  background: white;
  border-radius: 24px;
  padding: 28px 24px;
  box-shadow: var(--adm-shadow);
  border: 1px solid var(--adm-gray-border);
  transition: transform 0.2s;
}

.feature-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 24px 40px rgba(29, 78, 78, 0.1);
}

.card-icon {
  font-size: 2.5rem;
  color: var(--adm-primary-dark);
  margin-bottom: 20px;
}

.list-item {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  align-items: flex-start;
}

.list-item i {
  color: var(--adm-accent-blue);
  font-size: 1.1rem;
  margin-top: 3px;
  min-width: 20px;
}

.stat-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-top: 40px;
}

.stat-card {
  background: var(--adm-primary-soft);
  border-radius: 32px;
  padding: 32px 24px;
  text-align: center;
}

.stat-number {
  font-size: 2.8rem;
  font-weight: 700;
  color: var(--adm-primary-dark);
  margin-bottom: 8px;
}

.client-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
}

.client-tag {
  background: white;
  border: 1px solid var(--adm-gray-border);
  padding: 8px 22px;
  border-radius: 40px;
  font-weight: 500;
  color: var(--adm-text-dark);
}

/* 技术架构卡片 */
.arch-card {
  background: var(--adm-primary-soft);
  border-radius: 32px;
  padding: 36px;
  margin-top: 30px;
}

.arch-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 24px;
}

.arch-item {
  background: white;
  border-radius: 24px;
  padding: 24px;
}

/* 合规认证 */
.compliance-badge {
  display: inline-block;
  background: var(--adm-accent-gold);
  color: #1e3c3c;
  padding: 8px 18px;
  border-radius: 40px;
  font-weight: 600;
  margin-right: 12px;
  margin-bottom: 12px;
}

/* FAQ */
.faq-list {
  max-width: 900px;
  margin: 40px auto 0;
}

.faq-item {
  padding: 22px 0;
  border-bottom: 1px solid var(--adm-gray-border);
}

.faq-question {
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  gap: 16px;
  color: var(--adm-text-dark);
}

.faq-question i {
  color: var(--adm-accent-gold);
}

.faq-answer {
  margin-top: 12px;
  color: #3f5465;
  padding-left: 40px;
}

.cta-block {
  background: var(--adm-primary-dark);
  border-radius: 56px;
  padding: 64px 56px;
  color: white;
  text-align: center;
}

.cta-block h2 {
  color: white;
}

.cta-block .btn-primary {
  background-color: white;
  color: var(--adm-primary-dark);
  margin: 0 8px;
}

.cta-block .btn-outline {
  border-color: white;
  color: white;
}

.cta-block .btn-outline:hover {
  background-color: white;
  color: var(--adm-primary-dark);
}

/* 模态框 */
.modal {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  border-radius: 40px;
  max-width: 500px;
  width: 90%;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.3);
  position: relative;
}

.close-modal {
  position: absolute;
  top: 20px;
  right: 24px;
  font-size: 28px;
  cursor: pointer;
  color: #999;
}

.modal h3 {
  margin-bottom: 24px;
}

.modal .form-group {
  margin-bottom: 20px;
}

.modal input, .modal textarea {
  width: 100%;
  padding: 12px 18px;
  border: 1px solid var(--adm-gray-border);
  border-radius: 30px;
  font-size: 1rem;
  outline: none;
}

.modal textarea {
  border-radius: 20px;
}

.modal .btn {
  width: 100%;
  margin-top: 10px;
}

footer {
  text-align: center;
  padding: 40px 0;
  color: #7f8d9c;
  border-top: 1px solid var(--adm-gray-border);
  margin-top: 40px;
}

/* 响应式 */
@media (max-width: 1000px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .card-grid-3, .card-grid-4, .stat-grid, .arch-grid {
    grid-template-columns: 1fr;
  }
  .adm-page h1 { font-size: 2.5rem; }
}

/* 核心模块卡片颜色 */
.module-red { border-top: 5px solid #e53e3e; }
.module-blue { border-top: 5px solid #3182ce; }
.module-green { border-top: 5px solid #38a169; }
.module-yellow { border-top: 5px solid #d69e2e; }
</style>
